import React, { ReactNode } from "react";
import { Box } from "@mui/material";

interface LoginTabPanelProps {
  children?: ReactNode;
  index: number;
  value: number | string;
}

const LoginTabPanel = ({ children, value, index, ...other }: LoginTabPanelProps) => {

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`login-tabpanel-${index}`}
      aria-labelledby={`login-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </Box>
  );
}

export default LoginTabPanel;